import { useGetMagazineTagListPageQuery } from '@/hooks/magazine/magazine.gql.impl';
import { parseMagazineTagList } from '@/parsers/Communication/magazine';
import { MagazineType } from '@/types/magazine';

const useGetFaqTagListPage = (size = 20, tagName: string) => {
  const { data: faqs, isLoading: faqsLoading } = useGetMagazineTagListPageQuery(
    {
      request: {
        size,
        tagName,
        contentType: MagazineType.FAQ,
      },
    },
    {
      select: (data) => parseMagazineTagList(data),
    },
  );

  return {
    faqs: faqs ?? [],
    faqsLoading,
  };
};
export default useGetFaqTagListPage;
